'use client'
import Link from 'next/link'
import Image from 'next/image'
import styled from 'styled-components'
import { Logo } from './Logo'
import { mq, vw } from '@/styles'

export const MainPickCountry = () => {
  return (
    <Main>
			<Logo forceColor='#76273C' />
      <h1>Piacere di averti qui! <br />Pick your country</h1>
			<ul>
				<li className='country-es'>
					<Link href="/es">
						<span>Spain</span>
						<Image src='/images/svg/shapes/es.svg' alt='Spain shape' width={20} height={20} unoptimized/>
					</Link>
				</li>
				<li className='country-uk'>
					<Link href="/en">
						<span>United Kingdom</span>
						<Image src='/images/svg/shapes/uk.svg' alt='UK shape' width={20} height={20} unoptimized/>
					</Link>
				</li>
				<li className='country-de'>
					<Link href="/de">
						<span>Germany</span>
						<Image src='/images/svg/shapes/de.svg' alt='Germany shape' width={20} height={20} unoptimized/>
					</Link>
				</li>
				<li className='country-fr'>
					<Link href="/fr">
						<span>France</span>
						<Image src='/images/svg/shapes/fr.svg' alt='France shape' width={20} height={20} unoptimized/>
					</Link>
				</li>
				<li className='country-pt'>
					<Link href="/pt">
						<span>Portugal</span>
						<Image src='/images/svg/shapes/pt.svg' alt='Portugal shape' width={20} height={20} unoptimized/>
					</Link>
				</li>
			</ul>
    </Main>
  )
}

const Main = styled.main`
	display: grid;
	grid-template-rows: auto auto 1fr auto;
  min-height: 100vh;
	padding: 10px 16px 80px;

	h1 {
		font-family: var(--font-manic);
		font-size: 40px;
		font-weight: 700;
		
		${mq.greaterThan('tablet')} {
			font-size: 50px;
		}
	}

	.logo {
		height: auto;
		margin: 0 auto;
		max-width: 200px;
		width: 100vw;
		margin-bottom: 60px;
	}

	ul {
		align-items: center;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 0;
		justify-content: center;
		padding: 40px 0;

		li {
			display: flex;
			align-items: center;
			gap: 16px;
			padding: 10px 10px 20px;
			width: 50%;

			${mq.greaterThan('mobile')} {
				width: 33.33%;
			}

			${mq.greaterThan('tablet')} {
				width: fit-content;
			}

			span {
				order: 2;
				font-family: var(--font-platform);
				font-size: 22px;
				font-weight: 500;
				opacity: 1;
				text-align: center;
				text-decoration: underline;
				text-decoration-color: transparent;
				transition: text-decoration-color 300ms ease, opacity 300ms ease;

				${mq.greaterThan('tablet')} {
					font-size: 24px;
					opacity: .7;
				}
			}

			img {
				height: 50px;
				object-fit: contain;
				transition: opacity 300ms ease;
				width: 100%;

				${mq.greaterThan('tablet')} {
					height: 150px;
					opacity: .2;
					width: ${vw(120, 'tablet')};
				}
			}

			a {
				align-items: center;
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;
				gap: 16px;
				min-width: 100px;
				width: 100%;

				&:hover {
					span {
						opacity: 1;
						text-decoration-color: var(--color-red);
					}

					img {
						opacity: 1;
					}
				}
			}
		}
	}
`